import React from 'react'

function TextPangkat({text, suffix}) {
  return (<p className='text-pangkat'>{text}<span className='suffix'>{suffix}</span></p>)
}

export default TextPangkat